const GET_TEACHER_ASSIGNMENTS = `query GetTeacherAssignments($entityId: ID!, $entityType: Entity!, $filter: AssignmentQueryFilter) {
  assignment(entityId: $entityId, entityType: $entityType, filter: $filter) {
    lessonPlanId
    curriculumInfo {
      curriculumId
      curriculumPlanId
      curriculumSkills {
        lessonName
        order
        skillId
        unitName
      }
    }
    assignmentId
    clpId
    dateTo
    dateFrom
    entityId
    entityType
    grade
    status
    parentId
    assignor
    assignmentType
    assignmentCategory
    manifest {
      storyId
      activityType
      status
      contentTags
      locale
      sequence
      skills {
        skillId
        unitName
        order
        lessonName
        isRepeated
      }
      activity {
        score_pass
        status
        storyId
        tags
        type
      }
    }
    resources
  }
}`; // TODO NOTE Probably no longer need activity array from manifest cause each obj in manifest is one activity

export default GET_TEACHER_ASSIGNMENTS;
